var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,_vm._g(_vm._b({tag:"component",class:_setup.twMerge(_setup.buttonVariants({ variant: _vm.variant, size: _vm.size, class: _vm.twClass }))},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }